import React from "react";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import TableHead from "@mui/material/TableHead";

const useStyles = makeStyles({
  table: {},
});

const OrderTillRefunds = (props) => {
  const { tillRefunds } = props;
  const classes = useStyles();

  return (
    <React.Fragment>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          size="small"
          aria-label="a dense table"
        >
          <TableHead>
            <TableCell colSpan="2">Refund Details</TableCell>
          </TableHead>
          <TableBody>
            {tillRefunds &&
              tillRefunds.length > 0 &&
              tillRefunds.map((item) => (
                <>
                  <TableRow>
                    <TableCell>Refund Amount: </TableCell>
                    <TableCell align="left">
                      {item.amount && `$${item.amount}`}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>Currency: </TableCell>
                    <TableCell align="left">{item.currency}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>Result result: </TableCell>
                    <TableCell align="left">{item.result}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan="2"></TableCell>
                    
                  </TableRow>

                </>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};

export default OrderTillRefunds;
